import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useUpdatePasswordWithToken = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.auth.updatePasswordWithToken(input), useMutationOptions);
};
//# sourceMappingURL=useUpdatePasswordWithToken.js.map